VjsAdmin.MarketingLinks = (function () {
    const $table = $('#marketing-links-table');

    const init = function () {
        initTable();

        $('.app-content').on('click', 'a.archive', function (e) {
            e.preventDefault();

            const param = {};
            param.id = $(this).attr('data-id');
            param.setArchvied = String($(this).attr('data-archived')) === 'null' ? 1 : 0;

            $.post(Slim.Router.pathFor('marketing.links.set_archived'), param, () => {
                $('#marketing-links-table').bootstrapTable('refresh');
            });
        });

        $('.app-content').on('click', 'a.copy-link', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            $('#linkUrl').show();
            $('#linkUrl').val(href);

            const copyText = document.getElementById('linkUrl');
            copyText.select();
            copyText.setSelectionRange(0, 99999);
            document.execCommand('copy');
            $('#linkUrl').hide();
        });
    };

    const initTable = function () {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#marketing-links-table',

            formatNoMatches() {
                return 'No Links Found';
            },

            idField: 'id',
            sortName: 'id',
            sortOrder: 'DESC',
            search_product: '',
            search_platform: '',

            url: Slim.Router.pathFor('marketing.links.json'),

            onPreBody(data) {
                VjsTable.tableDefaults().onPreBody.call(this, data);

                const table = this;

                $('#search-product').off();
                $('#search-product').on('change', () => {
                    table.search_product = $('#search-product option:selected').val();
                    table.updateUrl();
                    $('#marketing-links-table').bootstrapTable('refresh');
                });

                if (typeof this.default_product === 'undefined') {
                    this.default_product = this.search_product;
                }
                this.search_product = $.urlParam('search_product') != null ? $.urlParam('search_product') : this.default_product;

                $(`#search-manager option[value="${decodeURIComponent(this.search_product)}"]`).attr('selected', true);

                $('#search-platform').off();
                $('#search-platform').on('change', () => {
                    table.search_platform = $('#search-platform option:selected').val();
                    table.updateUrl();
                    $('#marketing-links-table').bootstrapTable('refresh');
                });

                if (typeof this.default_platform === 'undefined') {
                    this.default_platform = this.search_platform;
                }
                this.default_platform = $.urlParam('default_platform') != null ? $.urlParam('default_platform') : this.default_platform;

                $(`#search-purchased-for option[value="${decodeURIComponent(this.default_platform)}"]`).attr('selected', true);
            },

            updateUrl() {
                const queryParams = {};

                if (this.search_product !== this.default_product) {
                    queryParams.search_product = this.search_product;
                }

                if (this.search_platform !== this.default_platform) {
                    queryParams.search_platform = this.search_platform;
                }

                VjsTable.tableDefaults().updateUrl.call(this, queryParams);
            },
            queryParams(params) {
                const myParams = VjsTable.tableDefaults().queryParams.call(this, params);

                myParams.platform_code = this.search_platform;
                myParams.product_code = this.search_product;
                return myParams;
            },
            columns: [
                {
                    title: 'ID',
                    field: 'id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Name',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Marketing Source',
                    field: 'platform_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Product',
                    field: 'product_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Page',
                    field: 'page_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Page URL',
                    field: 'page_url',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'Code',
                    field: 'code',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'Created',
                    field: 'created_at',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: '',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];

                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);
                    row.is_active = row.active;

                    if (VjsAdmin.hasPermission('marketing.links.edit.view')) {
                        const url = Slim.Router.pathFor('marketing.links.edit.view', { id: row.id });
                        row.actions = `<a href="${url}" class="btn btn-hollow-blue">Edit</a>`;

                        if (String(row.archived_at) === 'null') {
                            row.actions += `<a href="" data-id="${row.id}" data-archived="${row.archived_at}" class="btn btn-hollow-pink archive" style="margin-left:5px; margin-right:5px;">Archive</a>`;
                        } else {
                            row.actions += `<a href="" data-id="${row.id}" data-archived="${row.archived_at}" class="btn btn-hollow-pink archive" style="margin-left:5px; margin-right:5px;">UnArchive</a>`;
                        }
                    }

                    const linkUrl = `${row.page_url}?_mc=${row.code}`;
                    row.actions += `<a href="${linkUrl}" class="btn btn-hollow-blue copy-link">Copy Link</a>`;
                });
                return formattedResult;
            },
        });
    };

    return {
        init,
    };
}());
